import { render } from "./FileMultiUpload.vue?vue&type=template&id=4724a6e6&scoped=true"
import script from "./FileMultiUpload.vue?vue&type=script&lang=js"
export * from "./FileMultiUpload.vue?vue&type=script&lang=js"

import "./FileMultiUpload.vue?vue&type=style&index=0&id=4724a6e6&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4724a6e6"]])

export default __exports__